var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    moduleId,
    hamiltonStories
  } = options;

__p+='\n\n';
 for(var i = 0; i < hamiltonStories.length; i++) { var article = hamiltonStories[i]; 
__p+='\n<div class="article-card-container hamilton-articles-container col-xs-12 col-sm-6 col-md-3" data-capi-id="'+
((__t=( article.id ))==null?'':__t)+
'" data-module-id="'+
((__t=(moduleId))==null?'':__t)+
'" data-position="'+
((__t=(i+1))==null?'':__t)+
'" origin-id="'+
((__t=(article.originId))==null?'':__t)+
'">\n  <div class="article-card">\n    <div class="article-card-header">\n      <span class="news-category" data-category="hamilton"> '+
((__t=( article.category))==null?'':__t)+
'</span>\n    </div>\n    <div class="article-card-title-container hamilton-card-title-container">\n      <a class="article-card-title hamilton-card-title" href="'+
((__t=( article.webLink ))==null?'':__t)+
'" data-omtag="news:article:network-recommend:headline:slot'+
((__t=(i+1))==null?'':__t)+
':'+
((__t=(article.publication))==null?'':__t)+
'">\n        '+
((__t=( (article.title)))==null?'':__t)+
'\n      </a>\n    </div> <!-- article-card-title -->\n    <div class="pos-relative card-image">\n      <a href="'+
((__t=( article.webLink ))==null?'':__t)+
'" data-omtag="news:article:network-recommend:image:slot'+
((__t=(i+1))==null?'':__t)+
':'+
((__t=(article.publication))==null?'':__t)+
'">\n        <img class="hamilton-article-card-image" alt="'+
((__t=( article.title ))==null?'':__t)+
'" src="'+
((__t=( article.images[0].image400Url+"&interlace=true" ))==null?'':__t)+
'" data-pin-nopin="true" />\n      </a>\n    </div> <!-- pos-relative -->\n    <div class="pos-relative">\n      <a href="'+
((__t=( article.domain ))==null?'':__t)+
'" data-omtag="news:article:network-recommend:logo:slot'+
((__t=(i+1))==null?'':__t)+
':'+
((__t=(article.publication))==null?'':__t)+
'">\n        <img class="hamilton-article-card-logo" src="'+
((__t=( article.logoSourceUrl ))==null?'':__t)+
'" />\n      </a>\n    </div> <!-- LOGO -->\n  </div> <!-- article-card -->\n</div> <!-- col-xs-12 -->\n';

}

__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/news_advice_hamilton_stories.jst.ejs